import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetDepartments(start, limit) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/department/",
        params: { start, limit },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetDepartment(id) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/department/" + id,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetDepartmentByUser(userId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/department/by-user/" + userId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateDepartment(department) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/department",
        data: department,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateDepartment(id, department) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/department/" + id,
        data: department,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddUsersToDepartment(id, users) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/department/" + id + "/users",
        data: { users },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRemoveUsersFromDepartment(id, users) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/department/" + id + "/users",
        data: { users },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteDepartment(id) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/department/" + id,
        withCredentials: true,
        crossorigin: true,
    });
}
